import React from 'react';
import { CertificateData } from '@/components/course/certificate/CertificateService';
import CertificateTemplate from '@/components/course/certificate/CertificateTemplate';

interface HiddenCertificateRendererProps {
  certificates: CertificateData[];
}

const HiddenCertificateRenderer: React.FC<HiddenCertificateRendererProps> = ({ certificates }) => {
  return (
    <div className="fixed -left-[9999px] -top-[9999px] w-0 h-0 overflow-hidden pointer-events-none">
      {certificates.map((cert) => (
        <div key={cert.id} id={`certificate-${cert.id}`}>
          <CertificateTemplate
            userName={cert.userName}
            courseTitle={cert.courseTitle}
            completionDate={cert.completionDate}
            quizAverage={cert.quizAverage}
            certificateNumber={cert.certificateNumber}
            verificationHash={cert.verificationHash}
          />
        </div>
      ))}
    </div>
  );
};

export default HiddenCertificateRenderer;
